export default "__VITE_ASSET__BjSMvmv0__"